import { queryOptions, useQuery } from '@tanstack/react-query'

import { apiClient } from '@/apiClient.ts'

interface UseGetAttributeGroupArgs {
  attributeGroupId: string
}

export const getAttributeQueryOptions = (args: UseGetAttributeGroupArgs) =>
  queryOptions({
    queryKey: ['attribute-groups', args.attributeGroupId],
    queryFn: async () => {
      const result = await apiClient['attribute-groups'][
        ':attributeGroupId'
      ].$get({
        param: args,
      })

      return result.json()
    },
  })

export const useGetAttributeGroup = (
  args: UseGetAttributeGroupArgs,
  options?: Partial<ReturnType<typeof getAttributeQueryOptions>>
) =>
  useQuery({
    ...getAttributeQueryOptions(args),
    ...options,
  })
